import { useAuth } from "react-oidc-context";
import databoxBG from "../assets/images/databox-bg4.png";
import databoxLogo from "../assets/images/DataBox-logo.svg";
import databoxPattern from "../assets/images/databox-pattern1.png";
import Button from "../components/Button";
import config from "../config";

const LoginPage = () => {
    const { signinRedirect } = useAuth();

    const handleSignIn = () => {
        localStorage.setItem("sign-in-pathname", window.location.pathname);
        signinRedirect();
    };

    return (
        <div className="w-full min-h-screen flex justify-center items-center bg-deep-ocean-20">
            <div
                className="relative w-full max-w-[22.5rem] h-[17.5rem] rounded-xl overflow-hidden inset"
                style={{
                    boxShadow: "0px 0px 20px rgba(28, 38, 40, 0.2)",
                }}
            >
                <div className="absolute inset-0 object-cover">
                    <img className="w-full h-full" src={databoxBG} alt="" />
                </div>
                <img
                    className="absolute max-w-none w-[140%] -bottom-px -left-[4.375rem]"
                    src={databoxPattern}
                    alt=""
                />
                <div className="absolute inset-0 flex flex-col items-center justify-center">
                    {config.partnerLogoUrl ? (
                        <img 
                            src={config.loginLogoUrl} 
                            alt="Partner logo" 
                            className="max-h-20 mb-12"
                        />
                    ) : 
                    (
                        <img
                            src={databoxLogo}
                            alt="Databox logo white"
                            className="mb-12"
                        />
                     )}
                    <Button onClick={handleSignIn}>Login</Button>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;
